<template>
  <div class="testInstitutionsDetail common_content">
    <div class="news_detail">
      <el-card class="box-card">
        <el-row :gutter="24">
          <el-col :xs="24" :sm="24" :md="24" v-if="testInstitutionContents">
            <div class="news_detail_top">
              <h4>{{testInstitutionContents.mechanismName}}</h4>
              <span @click="goBack">返回</span>
            </div>
            <!-- <div v-if="introduce" class="news_detail_bottom" v-html="introduce"></div>
            <no-data v-else /> -->
            <div class="test_base_info">
              <div style="text-align: center;">
                <el-image
                  style="width: 40%; height: 30%;"
                  :src="getImgUrl(testInstitutionContents.institutionalView1)"
                ></el-image>
              </div>
              <div class="base_title">
                <p>
                  {{testInstitutionContents.mechanismName}}，注册地址：{{testInstitutionContents.detailAddress}}
                </p>
                <!--<p style="color:red">{{testInstitutionContents.createTime}}</p>-->
                <div v-for="(item,index) in testInstitutionContents.detailList" :key="index" style="margin-top: 15px">
                  <p>测试时间：<span style="color:red">{{item.testTime}}</span></p>
                  <p>测试标题：<span style="color:red">{{item.testTitle}}</span></p>
                  <p>测试级别：<span style="color:red">{{item.testLevels}}</span></p>
                  <p>考评组长：<span style="color:red">{{item.coachLeader}}</span></p>
                  <p>考评员：<span style="color:red">{{item.coachs}}</span></p>
                  <p>参加测试人数：<span style="color:red">{{item.testCount}}</span></p>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import { getTestMechanismData2 } from "@/api/admin/test.js";
// import noData from "@/views/admin/components/noData.vue";
export default {
  // components: {
  //   noData
  // },
  data() {
    return {
      testInstitutionContents: {},
      newsId: "",
      imgPath: window.apiObj.apiUrl,
      introduce: "",
      /*test_levels:"",  //测试级别
      test_coachleaders:"",  //考评组长
      test_coachs:""  //考评员*/
    };
  },
  created() {
    this.path();
    this.getDetail();
  },
  methods: {
    getImgUrl(file_path) {
      //获取图片完整路径
      var url = this.imgPath + file_path;
      return url;
    },
    path() {
      var pathList = [
        { title: "您当前的位置" },
        { title: "首页", path: "/index" },
        { title: "测试机构", path: "/testInstitutions" },
        {
          title: "测试机构详情"
        }
      ];
      setTimeout(() => {
        this.$store.commit("SET_ROUTELIST", pathList);
      });
    },
    getDetail() {
      this.newsId = this.$route.query.id;
      getTestMechanismData2(Object.assign({ id: Number(this.newsId) })).then(
        data => {
          var list = data.data.result;
          if (list) {
            this.testInstitutionContents = list.items[0];
            /*this.test_levels = this.testInstitutionContents.testLevels.join(',');  //测试等级列表
            this.test_coachleaders = this.testInstitutionContents.coachLeader.join(',');  //考评组长
            this.test_coachs = this.testInstitutionContents.coachs.join(',');  //考评员*/
            this.testInstitutionContents.detailList.forEach(it => {
              it.testLevels = it.testLevels.join(',');
              it.coachLeader = it.coachLeader.join(',');
              it.coachs = it.coachs.join(',');
            })
            if (list.items[0].introduce) {
              this.introduce = list.items[0].introduce.replace(
                new RegExp("/wwwroot", "gm"),
                this.imgPath
              );
            }
          }
        }
      );
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.testInstitutionsDetail {
  .news_detail {
    .base_title{
      padding-left: 10%;
    }
    .news_detail_top {
      padding-top: 15px;
      width: 85%;
      margin: auto;
      position: relative;
      h4 {
        text-align: center;
        font-size: 20px;
        font-weight: normal;
      }
      .date {
        text-align: center;
        font-size: 14px;
        color: #8a8a8a;
        margin: 20px 0 25px 0;
        border-bottom: 1px solid #cdcccc;
        padding-bottom: 15px;
      }
      & > span {
        cursor: pointer;
        position: absolute;
        color: #f56c6c;
        top: 26%;
        right: 0;
      }
    }
    .news_detail_bottom {
      width: 85%;
      margin: auto;
    }
  }
}
</style>
